<template>
  <div class="container">
    <div class="pt-3">
      <p>Article 1</p>
      <p>2023/02/11</p>
      <p v-if="routeName == rName + '/importance-of-cyber-security'">
        <router-link
          v-bind:to="rName + '/importance-of-cyber-security'"
          class="articleOne"
          >The Importance of Cybersecurity in the Marine Industry</router-link
        >
      </p>
      <p v-else>
        <router-link
          v-bind:to="rName + '/importance-of-cyber-security'"
          class="link"
        >
          The Importance of Cybersecurity in the Marine Industry
        </router-link>
      </p>
    </div>
    <hr />
    <div class="pt-5">
      <p>Article 2</p>
      <p>2023/02/15</p>
      <p
        v-if="
          routeName == rName + '/benefits-if-erp-integration-marine-industry'
        "
      >
        <router-link
          v-bind:to="rName + '/benefits-if-erp-integration-marine-industry'"
          class="articleTwo"
          >The Benefits of ERP Integration in the Marine Industry</router-link
        >
      </p>
      <p v-else>
        <router-link
          v-bind:to="rName + '/benefits-if-erp-integration-marine-industry'"
          class="link"
          >The Benefits of ERP Integration in the Marine Industry</router-link
        >
      </p>
    </div>

    <hr />
    <div class="pt-5">
      <p>Article 3</p>
      <p>2023/02/17</p>

      <p
        v-if="
          routeName == rName + '/future-software-development-in-marine-industry'
        "
      >
        <router-link
          v-bind:to="rName + '/future-software-development-in-marine-industry'"
          class="articleThree"
          >The Future of Software Development in the Marine
          Industry</router-link
        >
      </p>
      <p v-else>
        <router-link
          v-bind:to="rName + '/future-software-development-in-marine-industry'"
          class="link"
          >The Future of Software Development in the Marine
          Industry</router-link
        >
      </p>
    </div>

    <hr />

    <div class="pt-5">
      <p>Article 4</p>
      <p>2023/02/20</p>
      <p
        v-if="
          routeName ==
          rName + '/benefits-of-marine-ship-safety-management-service'
        "
      >
        <router-link
          v-bind:to="
            rName + '/benefits-of-marine-ship-safety-management-service'
          "
          class="articleFour"
          >Benefits of Marine Ship Safety Management Software</router-link
        >
      </p>
      <p v-else>
        <router-link
          v-bind:to="
            rName + '/benefits-of-marine-ship-safety-management-service'
          "
          class="link"
          >Benefits of Marine Ship Safety Management Software</router-link
        >
      </p>
    </div>
  </div>

  <!-- End of Sidebar -->
</template>

<script>
export default {
  data() {
    return {
      rName: "",
      routeName: "",
    };
  },
  mounted() {
    this.rName = localStorage.getItem("blogName");
    this.routeName = this.$router.history.current.path;
    console.log(this.routeName);
  },
};
</script>

<style scoped>
.link {
  text-decoration: none;
  color: #000000;
}
.container {
  color: #000000;
}
hr {
  border: 7px solid white;
}
.link:active {
  color: rgb(11, 91, 99);
  text-decoration: none;
}
.articleFour {
  color: rgb(5, 86, 148);
  text-decoration: none;
}
.articleOne {
  color: rgb(5, 86, 148);
  text-decoration: none;
}
.articleTwo {
  color: rgb(5, 86, 148);
  text-decoration: none;
}
.articleThree {
  color: rgb(5, 86, 148);
  text-decoration: none;
}
</style>
